import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MyOrdersPage.module.css';
import ConnUrls from '../Connections/ConnectURL';
import PlusMinusSelect from '../ForAllComponents/PlusMinusSelect';

import { TheOrderContext } from '../Contexts/TheOrder_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import TimeAndDateSelctionPop from '../PopUps/TimeAndDateSelctionPop';
import { UserContext } from '../Contexts/User_Context';
import LogOrRegPagePop from '../PopUps/LogOrRegPagePop';
import UserAdresses from '../PopUps/UserAdresses';
import { MasterContext } from '../Contexts/Master_Context';
import GetSpecialRemarks from '../PopUps/GetSpecialRemarks';
import MyFunctions from '../Functions/MyFunctions';
import { ArrowCircleLeftOutlined } from '@mui/icons-material';
import FinishedOrder from '../PopUps/FinishedOrder';
import OrederApprovedPop from '../PopUps/OrederApprovedPop';
import PaymentTypePop from '../PopUps/PaymentTypePop';
import utilsOrders from '../Connections/_Utils/utilsOrders';
import PopUpCCTokensCharge from '../PopUps/PopUpCCTokensCharge';
import PopUpCardComIframe from '../PopUps/PopUpCardComIframe';
import utilsUsers from '../Connections/_Utils/utilsUsers';
import utilsCardCom from '../Connections/_Utils/utilsCardCom';
import { SpecialUserContext } from '../Contexts/SpecialUser_Context';
import NoOrdersPop from '../PopUps/NoOrdersPop';
import MyOrdItem from './MyOrdItem';
import MyDateTime from '../ForAllComponents/MyDateTime';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const MyOrdersPage = (props) => {
    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [allMyOrders, setAllMyOrders] = useState([]);
    const [user, setUser, UsspecialUsererEffectFunction] = useContext(UserContext);
     const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [specialUser, setSpecialUser] = useContext(SpecialUserContext);
    const [openRemarks, setOpenRemarks] = useState(null); // State to track which remarks section is open
    const [remarks, setRemarks] = useState({}); // State to track remarks input for each item
    const [orderRemarks, setOrderRemarks] = useState();
    const [thePopUp, setThePopUp] = useState();

    const [selectdedDateTime, setSelectdedDateTime] = useState();
    const [theSeleAddress, setTheSeleAddress] = useState();
    const [toShow, setToShow] = useState();
    const [loading, setLoading] = useState(true);
    const [srchOrdsmsg, setSrchOrdsmsg] = useState("מחפש הזמנות");



    const [orderTry, setOrderTry] = useState(false);

    const navigate = useNavigate();
    let popsCount = 0;

    useEffect(() => {
        let tempHomP = { pageName: "ההזמנות שלי" }
        setCurrentPage({ ...tempHomP, pageTYp: "" });
    }, []);


    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            // כאשר יש נתוני משתמש, סיום מצב הטעינה
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        if (!loading && (!user || Object.keys(user).length === 0)) {
            navigate("/");
        } else if (!loading) {
            // המשך הלוגיקה הרגילה כאשר יש משתמש
            const getOrds = async () => {
                let allMyOrders = await utilsUsers.getUsersOrders(user._id);
                setAllMyOrders(allMyOrders);
                setSrchOrdsmsg(!allMyOrders || allMyOrders.length <= 0 ? "לא נמצאו הזמנות" : "")

                setLoading(false);
            };
            getOrds();
        }
    }, [loading, user]);

    const showIt = (itmId) => {
        setToShow(toShow !== itmId ? itmId : "");
    }

    return (
        <div className={`${styles.MyOrdersPage} regularPoint`}>
            <div className={styles.mainHeader}>ההזמנות שלי</div>
            {/* {!loading && */}
            <div className={styles.tableWrapper}>
                {allMyOrders.length <= 0 ?
                    <div className={"bold centerText"}>מחפש הזמנות</div>
                    :
                    <>
                        {allMyOrders?.slice().reverse().map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className="grayFrame" onClick={() => showIt(item._id)}>
                                        <div className={"bold centerText pointing"}>
                                            <div className={"bold big"}>הזמנה: {item.orderNUM}</div>
                                            <div> נוצר ב: {MyDateTime.getDate(item.dateCreated)} , מועד המסירה: {MyDateTime.getDateAndTime(item.dateToDeliver)}, סטטוס: {item.orderStatus}
                                            </div>
                                        </div>
                                        {
                                            toShow === item._id &&
                                            <MyOrdItem theordr={item} />
                                        }
                                    </div>
                                </div>

                            )

                        })}
                    </>
                }
            </div>

            {/* } */}
            {thePopUp}
        </div >
    );
};

export default MyOrdersPage;
